import LinkIcon from '@mui/icons-material/Link';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useMultiSelectionContext } from 'utils/providers/MultiSelectionProvider';
import { Search, SearchIconWrapper, StyledInputBase } from '../../common/Search';

interface FileManagerModalInputDialogContentSelectedProps {
  source?: string,
}
export const FileManagerModalInputDialogContentSelected = ({ source, ..._props }: FileManagerModalInputDialogContentSelectedProps) => {
  const { selection } = useMultiSelectionContext();
  const [url, setUrl] = useState('');
  const formContext = useFormContext();
  const { watch } = formContext ? formContext : { watch: (source: string) => null };
  const value = source ? watch(source) : null;

  useEffect(() => {
    // console.log(value);
    if (undefined !== value && null !== value) {
      setUrl(value.src);
    }
  }, [value]);

  useEffect(() => {
    if (selection.length > 0) {
      setUrl(selection[0].src);
    }
  }, [selection]);

  return (
    <Search style={{ flex: 1, backgroundColor: 'lightgray' }}>
      <SearchIconWrapper><LinkIcon /></SearchIconWrapper>
      <StyledInputBase
        placeholder="Selected URL"
        inputProps={{ style: { flex: 1 } }}
        value={url}
        onFocus={(e) => {
          e.preventDefault();
          e.stopPropagation();
          e.target.select();
          document.execCommand('copy');
          // e.target.blur();
        }}
        sx={{ flex: 1, }}
      />
    </Search>
  )
}
